import { FreeTextInput, FreeTextInputProps } from "../FreeTextInput/FreeTextInput"

export const LongTextQuestion = (props: FreeTextInputProps) => {
    return <FreeTextInput {...props} multiline />
}
